import { AxiosRequestConfig } from "axios";

export const postFeedbackReviewConfig = (qrReference: string): AxiosRequestConfig => ({
  method: "post",
  url: `/qrcode/${qrReference}/review`,
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
  },
});
